const TIME_REGEX = /^(:?[0-1][0-9]|:?2[0-3]):(:?00|[0-5][0-9])$/

export class CelebrationTime {
  private _time: string

  constructor (time: string) {
    if (!TIME_REGEX.test(time) && (time !== '-')) {
      throw new TypeError('Time provided doesn\'t match with format hh:mm')
    }
    this._time = time
  }

  time (): string {
    return this._time
  }
}
